// supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// Environment variables with fallbacks and validation
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Enhanced validation with better error messages
if (!supabaseUrl || !supabaseAnonKey) {
  const missingVars = [];
  if (!supabaseUrl) missingVars.push('REACT_APP_SUPABASE_URL');
  if (!supabaseAnonKey) missingVars.push('REACT_APP_SUPABASE_ANON_KEY');
  
  console.error('❌ Missing Supabase environment variables:', missingVars);
  console.error('📋 Available env vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP')));
  
  throw new Error(`Missing required environment variables: ${missingVars.join(', ')}. Please check your .env file and Cloudflare Pages environment variables.`);
}

// Validate URL format
try {
  new URL(supabaseUrl);
} catch (error) {
  console.error('❌ Invalid Supabase URL format:', supabaseUrl);
  throw new Error(`Invalid REACT_APP_SUPABASE_URL format: ${supabaseUrl}. Must be a valid URL starting with https://`);
}

console.log('✅ Supabase client initializing with URL:', supabaseUrl.substring(0, 30) + '...');

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      // Add debug logging in development
      debug: process.env.NODE_ENV === 'development'
    }
  }
);
